/** Ask first; use real Shopify Markets currencies and retain explicit choices. */
(() => {
  const configNode = document.getElementById('BardemLocalizationPreferences');
  const restoreForm = document.getElementById('BardemAutomaticLocalization');
  const owner = document.getElementById('BardemLocalizationNotice');
  const dialog = owner?.querySelector('dialog');
  const form = document.getElementById('BardemLocalizationNoticeForm');
  if (!configNode || !(restoreForm instanceof HTMLFormElement) || !(form instanceof HTMLFormElement) ||
      !(dialog instanceof HTMLDialogElement) || window.Shopify?.designMode) return;
  let config;
  try { config = JSON.parse(configNode.textContent || '{}'); } catch { return; }
  if (!Array.isArray(config.languages) || !Array.isArray(config.countries)) return;
  const root = document.documentElement;
  const url = new URL(location.href);
  if (url.searchParams.has('preview_theme_id') || url.searchParams.has('preview_key') ||
      /bot|crawler|spider|headless/i.test(navigator.userAgent)) return;

  const preferenceKey = 'bardem:localization-preferences:v1';
  const decisionKey = 'bardem:localization-notice:v1';
  const shownKey = 'bardem:localization-notice-shown:v1';
  const cacheKey = 'bardem:localization-recommendation:v1';
  const lifetime = 180 * 24 * 60 * 60 * 1000;
  const countries = new Map(config.countries.map(country => [country.code, country.currency]));
  const english = config.languages.find(code => code.toLowerCase().split('-')[0] === 'en');
  const fresh = (value, age = lifetime) => value && Number.isFinite(value.time) &&
    Date.now() - value.time >= 0 && Date.now() - value.time < age;
  // Accessing storage itself can throw in privacy-restricted browsers.
  const saved = (key, session = false) => {
    try { return JSON.parse((session ? sessionStorage : localStorage).getItem(key) || 'null'); } catch { return null; }
  };
  const write = (key, value, session = false) => {
    try { (session ? sessionStorage : localStorage).setItem(key, JSON.stringify(value)); } catch { /* Native cookies still work. */ }
  };
  let answered = false;
  let unlockPopup;
  function remember(choice) {
    answered = true;
    write(decisionKey, { time: Date.now(), choice });
    write(preferenceKey, {
      time: Date.now(),
      language: choice === 'accepted' ? form.querySelector('[name="language_code"]').value : config.language,
      country: choice === 'accepted' ? form.querySelector('[name="country_code"]').value : config.country,
    });
    write(shownKey, { time: Date.now() }, true);
    try {
      document.cookie = 'bardem_localization_notice=' + encodeURIComponent('v1:' + Date.now()) +
        '; Path=/; Max-Age=' + lifetime / 1000 + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    } catch { /* This document still remembers the answer if storage is blocked. */ }
  }
  function cookieAnswered() {
    try {
      const value = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith('bardem_localization_notice='));
      const token = value && decodeURIComponent(value.slice(value.indexOf('=') + 1)).split(':');
      return token?.[0] === 'v1' && fresh({ time: Number(token[1]) });
    } catch { return false; }
  }
  function returnTo(targetForm) {
    let field = targetForm.querySelector('[name="return_to"]');
    if (!field) {
      field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; targetForm.append(field);
    }
    field.value = location.pathname + location.search + location.hash;
  }

  // Restore only a previously explicit choice, never a first-visit guess.
  // Shopify's form/cookies remain responsible for real prices and checkout.
  const preferences = saved(preferenceKey);
  if (fresh(preferences) && (preferences.language || preferences.country)) {
    const language = config.languages.includes(preferences.language) ? preferences.language : config.language;
    const country = countries.has(preferences.country) ? preferences.country : config.country;
    const attempt = saved('bardem:localization-attempt:v1', true);
    let guarded = false;
    try {
      guarded = sessionStorage.getItem('bardem:localization-initialized:v1') !== 'true' && !fresh(attempt, 60000);
      if (guarded) sessionStorage.setItem('bardem:localization-initialized:v1', 'true');
    } catch { /* Never risk a redirect loop without its session guard. */ }
    if (guarded && !root.hasAttribute('data-localization-manual-choice') &&
        (language !== config.language || country !== config.country)) {
      restoreForm.querySelector('[name="language_code"]').value = language;
      restoreForm.querySelector('[name="country_code"]').value = country;
      write('bardem:localization-attempt:v1', { time: Date.now(), language, country }, true);
      returnTo(restoreForm);
      restoreForm.requestSubmit();
    }
    return;
  }
  if (!english || fresh(saved(decisionKey)) || cookieAnswered() || fresh(saved(shownKey, true), 24 * 60 * 60 * 1000) ||
      root.hasAttribute('data-localization-manual-choice')) return;

  const device = (navigator.languages?.[0] || navigator.language || '').toLowerCase().replaceAll('_', '-');
  const deviceEnglish = device.split('-')[0] === 'en';
  const englishCountries = new Set(['US', 'GB', 'IE', 'CA', 'AU', 'NZ', 'ZA', 'SG', 'BZ', 'JM', 'TT', 'BS', 'BB',
    'AG', 'DM', 'GD', 'KN', 'LC', 'VC', 'GY', 'NG', 'GH', 'KE', 'UG', 'ZM', 'ZW', 'BW', 'LS', 'SZ', 'MT', 'FJ',
    'IN', 'PK', 'PH', 'TZ', 'RW', 'MW', 'LR', 'SL', 'GM', 'SS', 'CM', 'SC', 'MU', 'PG', 'SB', 'VU', 'WS', 'TO',
    'TV', 'KI', 'NR', 'PW', 'FM', 'MH', 'HK']);

  async function recommend() {
    const cached = saved(cacheKey, true);
    if (fresh(cached, 30 * 60 * 1000)) return cached.country;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2000);
    let country = config.country;
    try {
      const endpoint = new URL((config.root || '/') + 'browsing_context_suggestions.json', location.origin);
      endpoint.searchParams.set('country[enabled]', 'true');
      endpoint.searchParams.set('language[enabled]', 'true');
      const response = await fetch(endpoint, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('No regional recommendation');
      const data = await response.json();
      const detected = data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle;
      if (typeof detected === 'string' && /^[A-Z]{2}$/.test(detected)) country = detected;
    } catch { /* Device language may still qualify; retain the current market currency. */ }
    finally { clearTimeout(timeout); }
    write(cacheKey, { time: Date.now(), country }, true);
    return country;
  }

  function chooseLanguage(code, updateCopy = true) {
    if (!config.languages.includes(code)) return;
    form.querySelector('[name="language_code"]').value = code;
    for (const button of form.querySelectorAll('[data-notice-language]')) {
      button.setAttribute('aria-pressed', String(button.dataset.noticeLanguage === code));
    }
    if (updateCopy) useCopy(code);
  }
  function chooseCountry(code) {
    if (!countries.has(code)) return;
    form.querySelector('[name="country_code"]').value = code;
    const currency = countries.get(code);
    form.querySelector('[data-notice-currency]').textContent = currency;
    for (const button of form.querySelectorAll('[data-notice-country]')) {
      if (button.dataset.noticeCurrencyCode === currency) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    }
    form.querySelector('currency-picker details').open = false;
    updateActions();
  }
  function positionCurrencies() {
    const picker = form.querySelector('currency-picker');
    if (!dialog.open || !picker?.querySelector('details')?.open) return;
    const trigger = picker.querySelector('summary').getBoundingClientRect();
    const bounds = dialog.getBoundingClientRect();
    const list = picker.querySelector('.header-market-controls__currency-list');
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    // Keep the floating list inside the visible dialog without adding scroll
    // overflow or shifting its content. Flip upward when there is more room.
    const below = Math.max(0, Math.min(bounds.bottom, viewportHeight) - trigger.bottom - 18);
    const above = Math.max(0, trigger.top - Math.max(bounds.top, 0) - 18);
    const upward = below < Math.min(220, list.scrollHeight) && above > below;
    picker.style.setProperty('--notice-currency-height', Math.floor(Math.min(220, upward ? above : below)) + 'px');
    picker.style.setProperty('--notice-currency-top', upward ? 'auto' : 'calc(100% + 6px)');
    picker.style.setProperty('--notice-currency-bottom', upward ? 'calc(100% + 6px)' : 'auto');
  }
  function updateActions() {
    const copy = dialog.lang === 'es' ? config.spanish : config.english;
    if (!copy) return;
    const language = form.querySelector('[name="language_code"]').value;
    const currency = countries.get(form.querySelector('[name="country_code"]').value);
    const currentCurrency = countries.get(config.country);
    const sameChoice = language === config.language && currency === currentCurrency;
    const languageName = code => copy.languageNames?.[code.toLowerCase().split('-')[0]] || code.toUpperCase();
    const label = (template, code, money) => template
      .replaceAll('[language]', languageName(code)).replaceAll('[currency]', money || '');
    dialog.querySelector('[data-notice-accept]').textContent = sameChoice ? copy.continue : label(copy.accept, language, currency);
    const decline = dialog.querySelector('[data-notice-decline]');
    decline.textContent = label(copy.decline, config.language, currentCurrency);
    decline.hidden = sameChoice;
  }
  function useCopy(code) {
    const language = code.toLowerCase().split('-')[0];
    const copy = language === 'es' ? config.spanish : config.english;
    if (!copy) return;
    dialog.lang = language;
    // Editor overrides belong to the rendered storefront language; never carry
    // that language's custom text into the other language's invitation.
    const custom = language === config.language.toLowerCase().split('-')[0] ? config.english : {};
    document.getElementById('LocalizationNoticeTitle').textContent = custom.title || copy.defaultTitle;
    document.getElementById('LocalizationNoticeMessage').textContent = custom.message || copy.defaultMessage;
    document.getElementById('LocalizationNoticeReminder').textContent = custom.reminder || copy.defaultReminder;
    dialog.querySelector('[data-notice-close]').setAttribute('aria-label', copy.close);
    updateActions();
  }

  async function offer() {
    const country = await recommend();
    if ((!deviceEnglish && !englishCountries.has(country)) || root.hasAttribute('data-localization-manual-choice')) return;
    const targetCountry = countries.has(country) && countries.get(country) !== countries.get(config.country) ? country : config.country;
    if (config.language === english && targetCountry === config.country) return;
    // Reuse the existing dialog, focus, scroll-lock and Back/Escape behavior.
    // These imports happen only when a visitor actually needs an invitation.
    try {
      await import('@theme/dialog');
      const utilities = await import('@theme/utilities');
      unlockPopup = utilities.unlockScroll;
    } catch { return; }
    if (!owner.isConnected || typeof owner.showDialog !== 'function') return;
    chooseLanguage(english, false);
    chooseCountry(targetCountry);
    useCopy(deviceEnglish || (!device.startsWith('es') && englishCountries.has(country)) ? english : config.language);
    form.querySelector('currency-picker details').addEventListener('toggle', positionCurrencies);
    dialog.addEventListener('scroll', positionCurrencies, { passive: true });
    window.addEventListener('resize', positionCurrencies, { passive: true });
    window.visualViewport?.addEventListener('resize', positionCurrencies, { passive: true });
    form.addEventListener('click', event => {
      const button = event.target instanceof Element && event.target.closest('button');
      if (button?.hasAttribute('data-notice-language')) chooseLanguage(button.dataset.noticeLanguage);
      if (button?.hasAttribute('data-notice-country')) chooseCountry(button.dataset.noticeCountry);
    });
    form.addEventListener('submit', event => {
      if (event.defaultPrevented) return;
      remember('accepted');
      if (form.querySelector('[name="language_code"]').value === config.language &&
          form.querySelector('[name="country_code"]').value === config.country) {
        event.preventDefault();
        void owner.closeDialog();
        return;
      }
      returnTo(form);
    });
    dialog.addEventListener('close', () => { if (!answered) remember('dismissed'); });
    window.addEventListener('pagehide', () => {
      if (dialog.open) { dialog.close(); unlockPopup?.(dialog); }
    }, { once: true });

    const pending = new AbortController();
    const { signal } = pending;
    let timer;
    const attempt = () => {
      clearTimeout(timer);
      if (answered || root.hasAttribute('data-localization-manual-choice')) { pending.abort(); return; }
      if (document.hidden || document.querySelector('product-overlay-hero[data-intro-pending], product-overlay-hero[data-building], product-overlay-hero[data-cover-loading]') ||
          document.querySelector('dialog[open], .header-hamburger[open], .header-inline-nav__disclosure[open], [data-cover-input-locked]')) return;
      if (document.activeElement?.matches('input, textarea, select')) return;
      pending.abort();
      write(shownKey, { time: Date.now() }, true);
      owner.showDialog();
    };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(attempt, 500); };
    document.addEventListener('hero:intro-settled', schedule, { signal });
    document.addEventListener('toggle', schedule, { capture: true, signal });
    document.addEventListener('visibilitychange', schedule, { signal });
    document.addEventListener('focusout', schedule, { signal });
    document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
    window.addEventListener('pagehide', () => { clearTimeout(timer); pending.abort(); }, { once: true, signal });
    schedule();
  }
  const start = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(() => { void offer().catch(() => {}); }, { timeout: 1500 });
    else setTimeout(() => { void offer().catch(() => {}); }, 500);
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
